import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    owner: null
  },
  mutations: {
    SET_OWNER (state, owner) {
      state.owner = owner
    }
  },
  actions: {
    setOwner (context, payload) {
      context.commit('SET_OWNER', payload)
    }
  },
  modules: {
  }
})
